import React from 'react';
import styled from 'styled-components';
import { Table, Message } from 'semantic-ui-react';

const StyledTable = styled(Table)`
 width: 700px !important;
  &&& {
    text-align: center;

    th, td {
      border: 1px solid #ccc;
      font-size: 13px !important;
    }

    th {
      background-color: #f7f7f7;
      font-size: 13px !important;
    }

    td {
      padding: 0.6rem;
      font-size: 13px !important;
    }
  }
`;

const Disclaimer = styled(Message)`
  &&& {
    margin-top: 2rem;
    background-color: #d9e2f3;
    color: #333;
    border: none;
  }
`;

const DieselConsumptionTable: React.FC = () => (
  <>
    <StyledTable celled compact={'very'}>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Arbeitsgang</Table.HeaderCell>
          <Table.HeaderCell>Durchgänge</Table.HeaderCell>
          <Table.HeaderCell>durchschnittlicher Dieselverbrauch</Table.HeaderCell>
          <Table.HeaderCell>Einheit</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Grundbodenbearbeitung (Pflug)</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>20</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Saatbettbereitung (Saatbettkombi)</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>4,6</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Einzelkornsaat, 6-reihig</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>4</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Walzen Saatbett/Ansaat</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>3,4</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Mineraldünger streuen</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>1,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Pflanzenbehandlung (Feldspritze)</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>1,4</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Bodenbearbeitung (Grubber), abhängig von Arbeitstiefe</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>13-17</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Gülle ausbringen ab Lager, Injektionsgrubber, 20 m3, 4m</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>16</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Gülle ausbringen ab Lager, Schleppschuh, 15 m3, 12m</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>9,6</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Festmist ausbringen ab Lager, Radlader 67 kW; Festmiststreuer 2,5 m³ und Festmiststreuer, 12 t; 120 kW</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>6</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Maisstoppeln mulchen</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>7,5</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Silomais Ernte</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>43,3</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Silomais einlagern</Table.Cell>
          <Table.Cell>1</Table.Cell>
          <Table.Cell>7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Silomais Transport (Feld‐Silo), durchschnittliche Entfernung 1 km</Table.Cell>
          <Table.Cell></Table.Cell>
          <Table.Cell>16,6</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Silomais Transport (Feld‐Silo), durchschnittliche Entfernung 2 km</Table.Cell>
          <Table.Cell></Table.Cell>
          <Table.Cell>21</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Silomais Transport (Feld‐Silo), durchschnittliche Entfernung 5 km</Table.Cell>
          <Table.Cell></Table.Cell>
          <Table.Cell>35</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Silomais Transport (Feld‐Silo), durchschnittliche Entfernung 10 km</Table.Cell>
          <Table.Cell></Table.Cell>
          <Table.Cell>56,7</Table.Cell>
          <Table.Cell>l/ha</Table.Cell>
        </Table.Row>
      </Table.Body>
    </StyledTable>

    <Disclaimer>
      Dies sind lediglich Orientierungswerte! Genauere und mehr Werte finden Sie im Internet auf der Seite des KTBL-Dieselbedarf-Rechners:{' '}
      <a href='https://daten.ktbl.de/dieselbedarf/home.html' target='_blank' rel='noopener noreferrer'>
        https://daten.ktbl.de/dieselbedarf/home.html
      </a>
    </Disclaimer>
  </>
);

export default DieselConsumptionTable;